module.exports = ":host {\n  display: block;\n  padding: 8px;\n  background: #263238;\n  cursor: text; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/highlight/highlight.component.scss
// module id = ./src/app/core/components/highlight/highlight.component.scss
// module chunks = main